import { PaginationType } from 'common';
import { TimeCodesActionType } from 'enums';
import { TimeCodeType } from 'state';

export const setTimeCodes = (timeCodes: TimeCodeType[]) =>
  ({ type: TimeCodesActionType.SET_TIME_CODES, timeCodes } as const);

export const updateTimeCode = (timeCode: TimeCodeType) =>
  ({ type: TimeCodesActionType.UPDATE_TIME_CODE, timeCode } as const);

export const setTimeCodesAfterScroll = (timeCodes: TimeCodeType[]) =>
  ({ type: TimeCodesActionType.SET_TIME_CODES_AFTER_SCROLL, timeCodes } as const);

export const setTimeCodesLoadingStatus = (isLoading: boolean) =>
  ({ type: TimeCodesActionType.SET_TIMECODES_LOADING_STATUS, isLoading } as const);

export const setTimeCodesPagination = (pagination: PaginationType) =>
  ({ type: TimeCodesActionType.SET_TIME_CODES_PAGINATION, pagination } as const);
